import { Flex, Group, NavLink, Paper, Text, ThemeIcon } from '@mantine/core'
import { IconPhoto, IconTrash } from '@tabler/icons-react'
import PolicyCheckHOC from '@v2/commons/HOC/policyCheckHOC'
import { bytesConverter } from '@v2/commons/utils/bytesConverter/bytesConverter.util'
import { WbfPolicies } from '@workers-benefit-fund/shared-data'

import styles from './preview-attachments.module.scss'

interface PrviewFileProps {
  url?: string
  error?: string
  size: number
  name: string
  id?: string
}

const PreviewAttachments = ({
  previewFiles,
  onDelete,
  hasViewAttachmentsPolicyEnabled = false,
}: {
  previewFiles: PrviewFileProps[]
  onDelete?: (idx: number, id?: string) => void
  hasViewAttachmentsPolicyEnabled?: boolean
}) => {
  return (
    <Paper mt={10}>
      {previewFiles.length > 0 &&
        previewFiles.map(({ url, name, size, error, id }, idx) => (
          <Paper className={styles.wrapper} key={`${name}-${idx}`}>
            <NavLink
              href={
                url && hasViewAttachmentsPolicyEnabled
                  ? `/attachment/${id}/form`
                  : undefined
              }
              target="_blank"
              mb={4}
              label={
                error ? (
                  <Group>
                    <Text fz="sm">{name}</Text>
                    <Text fw="bold" fz="sm" c="var(--mantine-color-red-6)">
                      {error}
                    </Text>
                  </Group>
                ) : (
                  name
                )
              }
              className={error ? styles['file-error'] : styles['file-success']}
              leftSection={<IconPhoto color="#3C5BFF40" />}
              rightSection={
                <Flex justify="right" mr={50}>
                  <Text size="sm"> {bytesConverter(size)} </Text>
                </Flex>
              }
            />
            <PolicyCheckHOC
              policyName={WbfPolicies.is_remove_form_attachment_enabled}
            >
              <ThemeIcon
                color="#FCE9E9"
                size={24}
                radius="xl"
                p={4}
                onClick={() => (onDelete ? onDelete(idx, id) : null)}
                className={styles['trash-icon']}
              >
                <IconTrash color="var(--mantine-color-red-6)" />
              </ThemeIcon>
            </PolicyCheckHOC>
          </Paper>
        ))}
    </Paper>
  )
}

export default PreviewAttachments
